import { Typography } from "antd";
const { Paragraph, Text } = Typography;

const DefaultParagraph = ({
  hideleader,
  nostartspace,
  leader,
  children,
  ...rest
}) => {
  return (
    <Paragraph style={{ maxWidth: 800 }} {...rest}>
      {nostartspace ? <></> : <>&nbsp;&nbsp;&nbsp;&nbsp;</>}
      {leader && (
        <>
          {<Text style={{ opacity: hideleader ? 0 : 1 }}>{leader}</Text>}
          &nbsp;&nbsp;
        </>
      )}
      {children}
    </Paragraph>
  );
};

export default DefaultParagraph;
